class SymfonyApiService {
    baseUrl;
    jwtToken = null;
    constructor(baseUrl = process.env.VITE_API_URL) {
        this.baseUrl = baseUrl;
        this.jwtToken = this.getStoredToken();
    }
    getStoredToken() {
        return localStorage.getItem('CHAT_AUTH_TOKEN') || null;
    }
    getHeaders() {
        const headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        };
        if (this.jwtToken) {
            headers['Authorization'] = `Bearer ${this.jwtToken}`;
        }
        return headers;
    }
    async requestUploadUrl(fileName, fileSize, fileType, sessionId) {
        const fullUrl = `${this.baseUrl}/api/chat/upload-url`;
        const headers = this.getHeaders();
        try {
            const response = await fetch(fullUrl, {
                method: 'POST',
                headers,
                body: JSON.stringify({
                    fileName,
                    fileSize,
                    fileType,
                    chatContext: 'live-session',
                    sessionId
                })
            });
            if (!response.ok) {
                const errorText = await response.text();
                throw new Error(`HTTP ${response.status}: ${response.statusText} - ${errorText}`);
            }
            const responseData = await response.json();
            return {
                success: true,
                uploadUrl: responseData.uploadUrl,
                readUrl: responseData.readUrl,
                gcpPath: responseData.gcpPath,
                error: responseData.error
            };
        }
        catch (error) {
            return {
                success: false,
                error: error instanceof Error ? error.message : 'Erreur inconnue'
            };
        }
    }
    /**
     * Uploader un fichier vers Google Cloud Storage
     */
    async uploadToGCS(uploadUrl, file) {
        return new Promise((resolve) => {
            const xhr = new XMLHttpRequest();
            xhr.open('PUT', uploadUrl, true);
            xhr.setRequestHeader('Content-Type', file.type);
            xhr.onload = () => {
                if (xhr.status >= 200 && xhr.status < 300) {
                    resolve(true);
                }
                else {
                    resolve(false);
                }
            };
            xhr.onerror = () => {
                resolve(false);
            };
            xhr.send(file);
        });
    }
    /**
     * Upload direct via Symfony (pas de CORS !)
     */
    async uploadDirect(file, options) {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('sessionId', options.roomId);
        formData.append('chatContext', options.chatContext);
        try {
            return new Promise((resolve, reject) => {
                const xhr = new XMLHttpRequest();
                xhr.upload.addEventListener('progress', (event) => {
                    if (event.lengthComputable) {
                        const progress = Math.round((event.loaded * 100) / event.total);
                    }
                });
                xhr.addEventListener('load', () => {
                    if (xhr.status >= 200 && xhr.status < 300) {
                        try {
                            const attachment = JSON.parse(xhr.responseText);
                            resolve(attachment);
                        }
                        catch (e) {
                            reject(new Error('Réponse invalide du serveur'));
                        }
                    }
                    else {
                        reject(new Error(`HTTP ${xhr.status}: ${xhr.statusText}`));
                    }
                });
                xhr.addEventListener('error', (e) => {
                    reject(new Error('Erreur réseau'));
                });
                xhr.addEventListener('timeout', () => {
                    reject(new Error('Timeout de la requête'));
                });
                xhr.timeout = 30000;
                xhr.open('POST', `${this.baseUrl}/api/chat/upload-direct`);
                xhr.setRequestHeader('Authorization', `Bearer ${this.jwtToken}`);
                xhr.send(formData);
            });
        }
        catch (error) {
            throw error;
        }
    }
    /**
     * Méthode POST générique pour les requêtes JSON
     */
    async post(endpoint, data, options) {
        const response = await fetch(`${this.baseUrl}${endpoint}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${this.jwtToken}`,
                ...options?.headers
            },
            body: JSON.stringify(data)
        });
        if (!response.ok) {
            throw new Error(`HTTP ${response.status}: ${response.statusText}`);
        }
        return response.json();
    }
    /**
     * Vérifier si l'utilisateur est authentifié
     */
    isAuthenticated() {
        return !!this.jwtToken && !this.jwtToken.includes('fake-signature');
    }
    /**
     * Mettre à jour le token JWT
     */
    updateToken(token) {
        this.jwtToken = token;
        localStorage.setItem('CHAT_AUTH_TOKEN', token);
    }
}
export const symfonyApi = new SymfonyApiService();
